
define('modules/application/wizard/classes/amplifierCommand',[
  "app",

  // Libs
  "backbone",

  // Classes
  "./genericCollectionSection",
  "./mainCommand"

],

function(app, Backbone, genericCollectionSection, mainCommand) {
  var amplifierCommandModel = mainCommand.Model.extend({
    initialize   : function() {
      mainCommand.Model.prototype.initialize.apply(this);
      this.set("name", "IDS_WAV8_13_1");
    },
    deliverModel : function() {
      var zonesItems         = BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesItems") : [],
          collection         = this.get("collection"),
          collectionLength   = collection.length,
          i                  = 0,
          j                  = 0;
      var objectToPush;

      switch (BticinoS4B.vars.system.id) {
        case '#2':
          BticinoS4B.solution.thermoregulation.amplifierCommand = this;
          break;
        case '#4':
          BticinoS4B.solution.intrusionDetection.amplifierCommand = this;
          break;
        case '#5+6':
          BticinoS4B.solution.audioVideo.amplifierCommand = this;
          break;
        case '#13+20':
          BticinoS4B.solution.automation.amplifierCommand = this;
          break;
        case '#13':
          BticinoS4B.solution.automationSimple.amplifierCommand = this;
          break;
        case '#21':
          BticinoS4B.solution.energyManagement.amplifierCommand = this;
          break;
      }

      BticinoS4B.Instances.Models.ApplicationModel.set("amplifierCommand", this);
    }
  });

  var amplifierCommand = _.extend({}, mainCommand, {
    Model : amplifierCommandModel
  });

  return amplifierCommand;
});